import { Box } from "@mui/material";
import { TabLinks } from "components/TabLinks";
import { useTenant } from "hooks/useTenant";
import { Outlet, useMatch } from "react-router-dom";

export function WasteInvoicesLayout() {
  const { tenantId } = useTenant();
  const base = `/o/${tenantId}/waste/invoices`;
  const auditMatch = useMatch({ path: `${base}/audit`, end: false });
  return (
    <Box>
      <TabLinks
        value={auditMatch ? `${base}/audit` : base}
        tabs={[
          { title: "Invoices", to: base },
          { title: "Audit", to: `${base}/audit` },
        ]}
        aria-label="invoice tabs"
        role="navigation"
      />
      <Outlet />
    </Box>
  );
}
